import { API } from "@/utils/api";

interface createEmailReceiverProps {
  email: string;
  label: string;
  redirect_url: string;
}
/* Create email receiver */
export const createEmailReceiver = async ({
  email,
  label,
  redirect_url,
}: createEmailReceiverProps) => {
  const response = await API().post(`/receiver/email`, {
    email,
    label,
    redirect_url,
  });
  return response.data.data.receiver;
};
/* verify email receiver */
export const verifyEmailReceiver = async (token: string) => {
  const response = await API().put(`/receiver/email`, {
    token,
  });
  return response.data.receiver;
};
interface resendEmailReceiverProps {
  id: string;
  redirect_url: string;
}
/* resend email */
export const resendReceiverEmail = async ({
  id,
  redirect_url,
}: resendEmailReceiverProps) => {
  const response = await API().get(
    `/receiver/${id}/_resend_email?redirect_url=${redirect_url}`,
  );
  return response.data;
};
/* resend sms */
export const resendReceiverSms = async (id: string) => {
  const response = await API().get(`/receiver/${id}/_resend_sms`);
  return response.data;
};
interface createSmsReceiverProps {
  phoneNumber: string;
  label: string;
}
/* Create sms receiver */
export const createSmsReceiver = async ({
  phoneNumber,
  label,
}: createSmsReceiverProps) => {
  const response = await API().post(`/receiver/sms`, {
    phoneNumber,
    label,
  });
  return response.data.data.receiver;
};
interface verifySmsReceiverProps {
  receiverId: string;
  code: string;
}
/* verify sms receiver */
export const verifySmsReceiver = async ({
  receiverId,
  code,
}: verifySmsReceiverProps) => {
  const response = await API().put(`/receiver/sms`, {
    receiverId,
    code,
  });
  return response.data.data.receiver;
};

interface createSlackReceiverProps {
  code: string;
  label: string;
}
/* Create slack receiver */
export const createSlackReceiver = async ({
  code,
  label,
}: createSlackReceiverProps) => {
  const response = await API().post(`/receiver/slack`, {
    code,
    label,
  });
  return response.data;
};
/* Create telegram receiver */
export const createTelegramReceiver = async (label: string) => {
  const response = await API().post(`/receiver/telegram`, {
    label,
  });
  return response.data.data.receiver;
};
/* verify telegram receiver */
export const verifyTelegramReceiver = async (token: string) => {
  const response = await API().put(`/receiver/telegram`, {
    token,
  });
  return response.data;
};
interface createDiscordReceiverProps {
  label: string;
  webhookUrl: string;
}
/* Create discord receiver */
export const createDiscordReceiver = async ({
  label,
  webhookUrl,
}: createDiscordReceiverProps) => {
  const response = await API().post(`/receiver/discord`, {
    label,
    webhookUrl,
  });
  return response.data.data.receiver;
};
interface createWebhookReceiverProps {
  label: string;
  webhookUrl: string;
  secret: string;
}
/* Create webhook receiver */
export const createWebhookReceiver = async ({
  label,
  webhookUrl,
  secret,
}: createWebhookReceiverProps) => {
  const response = await API().post(`/receiver/webhook`, {
    label,
    webhookUrl,
    secret,
  });
  return response.data.data.receiver;
};

interface updateWebhookReceiverProps {
  receiverId: string;
  webhookUrl: string;
  secret: string;
  label: string;
}
/* Update webhook url */
export const updateWebhookReceiver = async ({
  receiverId,
  webhookUrl,
  secret,
  label,
}: updateWebhookReceiverProps) => {
  const response = await API().put(`/receiver/${receiverId}/_update_webhook`, {
    webhookUrl,
    secret,
    label,
  });
  return response.data.data.receiver;
};

interface createCircuitBreakerReceiverProps {
  label: string;
  tx: string;
  network: "Mainnet-beta" | "Devnet" | "Mainnet" | "Testnet";
  chain?: "Solana" | "Ethereum" | "Polygon zkEVM";
}
/* Create Circuit breaker receiver */
export const createCircuitBreakerReceiver = async ({
  label,
  tx,
  network,
  chain = "Solana",
}: createCircuitBreakerReceiverProps) => {
  const response = await API().post(`/receiver/circuit_breaker`, {
    label,
    tx,
    network,
    chain,
  });
  return response.data.data.receiver;
};
/* Test webhook url */
export const testWebhookReceiver = async (receiverId: string) => {
  const response = await API().put(`/receiver/${receiverId}/_test_webhook`, {});
  return response.data.data.message;
};

/* Get an receiver */
export const getReceiver = async (id: string) => {
  const response = await API().get(`/receiver/${id}`);
  return response.data;
};
/* Delete an receiver */
export const deleteReceiver = async (id: string) => {
  const response = await API().delete(`/receiver/${id}`);
  return response.data;
};
/* Get all receiver */
export const getAllReceivers = async () => {
  const response = await API().get(`/receivers`);
  return response.data.data.receivers || [];
};
